module.exports = __webpack_public_path__ + "img/img-8.c4631d18.png";